import React, { useContext } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import { AuthContext } from "../context/AuthContext";
import { useLocation } from "react-router-dom";

const Layout = (props) => {
  const { isAuthenticated } = useContext(AuthContext);
   const location = useLocation();

   const hideFooterRoutes = [
    '/tools/beyondstay-checkout',
    '/tools/beyond-stay',
    '/tools/beyond-ease',
    '/tools/beyond-concierge',
    '/tools/beyond-calendar',
    '/tools/beyond-mail'
  ];

  const shouldHideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <>
      <Header />
      <div id="home" className="">
        {props?.children}
      </div>
      {/* {isAuthenticated ? "" : <Footer />} */}
       {!isAuthenticated && !shouldHideFooter && <Footer />}
    </>
  );
};

export default Layout;
